'use strict';

/* jshint -W098 */
angular.module('mean.company-factors').controller('TradeAdminCostsController', ['$scope', 'Global', 'Users', 'MeanUser', 'Trades', 'userService', 'toaster',
  function($scope, Global, Users, MeanUser, Trades, userService, toaster) {
    $scope.global = Global;
    $scope.package = {
      name: 'company-factors'
    };

    $scope.user = MeanUser.user;

    $scope.update = function() {
        $scope.selectedItem.$update(function(saved) {
            toaster.pop('success', 'Trade Costs', 'Database update successfully.');
        }, function(error) {
            toaster.pop('error', 'Trade Costs', 'Could not update the database.');
        });
    };

    $scope.init = function() {
        if(userService.isAdmin($scope.user)) {
            userService.getMainAccountId($scope.user.username).then(function(id) {
                Trades.query({'main_account_id': id}, function(trade) {
                    if(trade.length === 0) {
                        toaster.pop('error', 'Trade Database', 'Please set up your company info first.');
                    }

                    if(trade.length === 1) {
                        $scope.selectedItem = trade[0];

                        //equipment tax was added after a lot of trades
                        //were created.  Update the rate to 0 for now.
                        if(!$scope.selectedItem.costs.equipment_tax) {
                            $scope.selectedItem.costs.equipment_tax = 0;
                            $scope.selectedItem.$update();
                        }
                    } else {
                        toaster.pop('error', 'Trade Costs', 'There was a problem getting the Trade database.');
                    }
                });
            });
        } else {
            toaster.pop('error', 'Trade Costs', 'You do not have proper permissions.');
        }
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/admin-panel/public/controllers/tradeAdminCosts.js